<template>
    <div class="contact-form">
        <el-form button-class="btn btn-primary btn-sm btn-rounded font-bold" @submit="submit" :loading="loading" :success="success" :error="server_error" :submit-text="translations.send_label" :disclaimer="translations.required_text">
            <el-input v-model="formData.name" rules="required" :label="translations.name_label" class="mb-16"></el-input>
            <el-input v-model="formData.email" rules="required|email" :label="translations.email_label" class="mb-16"></el-input>
            <el-input v-model="formData.description" rules="required" :label="translations.message_label" type="textarea" class="mb-24"></el-input>
            <p class="text-blue opacity-50 text-10 mt-16">Deze site wordt beschermd door reCAPTCHA en het Google <a class="underline hover:no-underline" href="https://policies.google.com/privacy">Privacybeleid</a> en <a class="underline hover:no-underline" href="https://policies.google.com/terms">Servicevoorwaarden</a> zijn van toepassing.</p>
        </el-form>
    </div>
</template>

<script>
import hasForm from '@mixins/components/has-form';

export default {
    name: 'Forms.ContactForm',

    mixins: [hasForm],

    props: {
        product: {
            type: String,
            required: false,
        },

        translations: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            formData: {
                name: '',
                email: '',
                description: '',
                product: this.product,
            },
        };
    },

    methods: {
        submit() {
            this.beforeSubmit();

            this.$recaptchaLoaded().then(() => {
                this.$recaptcha('login').then(token => {
                    this.formData['g-recaptcha-response'] = token;

                    axios
                        .post(`/api/contact?locale=${document.documentElement.lang}`, this.formData)
                        .then(response => {
                            this.handleSuccess();
                        })
                        .catch(e => this.handleError(e));
                });
            });
        },
    },
};
</script>
